import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ShareIcon from '@mui/icons-material/Share';
import TodayIcon from '@mui/icons-material/Today';
import { useAnimate } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MaterialButton from '../../../maker/component/MaterialButton';
import { setStoryClicked1Time } from '../../Player';
import { PlayerContext } from '../../PlayerContext';
import { darkerColor, getTextWidth } from '../../Utils';
import { storyHasOrderingPlatforms } from '../../chainRestaurantUtils';
import './../../Player.css';
import { Moped } from '@mui/icons-material';

export const bookType = "book";
export const shareType = "share";
export const contactType = "contact";
export const applyType = "apply";
export const orderType = "order";

function PrimaryButton(props){
    const { t } = useTranslation();

    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const primaryColor = useContext(PlayerContext).get("primaryColor");
    const secondaryColor = useContext(PlayerContext).get("secondaryColor");    
    const defaultColor = "#FFFFFF";
    const highlight = useContext(PlayerContext).get("highlight");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");
    const setPlayInteractiveAnimation = useContext(PlayerContext).get("setPlayInteractiveAnimation");
    const [scope, animate] = useAnimate();
    
    let icon = "#";
    let textKey = "";
    let refBtnType = "BookButton";    
    if ((props.story.posBookingLink == null || props.story.posBookingLink === "none") && !storyHasOrderingPlatforms(props.story) /*&& !props.story.posBookingByPhone*/ || props.story.posId === "ChIJC4g4KBNx5kcRH_z3vKUpnZw")
        refBtnType = "ContactButton";
    else if ((props.story.posBookingLink == null || props.story.posBookingLink === "none") && storyHasOrderingPlatforms(props.story))
        refBtnType = "OrderButton";
    
    if (props.storyId === "cJU0Fnom8MTjmokacI3I" || props.storyId === "WX2KsZRK4SNKT9hnNIp0"){
        refBtnType = "ApplyButton";
    }    
    const maxTextWidth = Math.max(getTextWidth(t(refBtnType), 18 + "px Roboto condensed"), getTextWidth(t('ShareButton'), 18 + "px Roboto condensed"));    
    const buttonWidth = (8 + 8 + 16 + 4 + maxTextWidth + 8 + 8 - 10) * sizeMultiplier;
    const buttonHeight = 36 * sizeMultiplier;
    let x = storyDimensions.containerWidth - buttonWidth - 8 * sizeMultiplier;
    let y = 0;
    let backgroundColor = "#FFFFFF";
    let textColor = "#000000";
    //alert(maxTextHeight);    

    switch (props.buttonType){
        case bookType: 
            icon = "/images/ic_today.png";        
            textKey = "BookButton";
            y = storyDimensions.containerHeight - 8 * sizeMultiplier - buttonHeight - 8 * sizeMultiplier - buttonHeight;
            backgroundColor = defaultColor;
            textColor = darkerColor(primaryColor, secondaryColor);            
            
            break;
        case shareType: 
            icon = "/images/ic_share.png";
            textKey = "ShareButton";
            if (props.storyId === "cJU0Fnom8MTjmokacI3I" || props.storyId === "WX2KsZRK4SNKT9hnNIp0"){
                textKey = "ShareShareButton";
            }

            y = storyDimensions.containerHeight - 8 * sizeMultiplier - buttonHeight;                
            backgroundColor = primaryColor;
            textColor = secondaryColor;
            
            break;
        case contactType: 
            icon = "/images/ic_contact.png";
            textKey = "ContactButton";

            y = storyDimensions.containerHeight - 8 * sizeMultiplier - buttonHeight - 8 * sizeMultiplier - buttonHeight;
            backgroundColor = defaultColor;
            textColor = darkerColor(primaryColor, secondaryColor);            
            
            break;
        case orderType: 
            icon = "/images/ic_order.png";
            textKey = "OrderButton";

            y = storyDimensions.containerHeight - 8 * sizeMultiplier - buttonHeight - 8 * sizeMultiplier - buttonHeight;
            backgroundColor = defaultColor;
            textColor = darkerColor(primaryColor, secondaryColor);            
            
            break;
        case applyType: 
            icon = "/images/ic_apply.png";
            textKey = "ApplyButton";

            y = storyDimensions.containerHeight - 8 * sizeMultiplier - buttonHeight - 8 * sizeMultiplier - buttonHeight;
            backgroundColor = defaultColor;
            textColor = darkerColor(primaryColor, secondaryColor);
            
            break;
        default:
            break;
    }

    useEffect(() => {
        if (highlight != null){

            let elementId = null;
            if (highlight.includes("book") && props.buttonType === bookType){
                elementId = "primary-btn-book";                
            }
            else if (highlight.includes("share") && props.buttonType === shareType){                
                elementId = "primary-btn-share";                
            }
            else if (highlight.includes("contact") && props.buttonType === contactType){
                elementId = "primary-btn-contact";                
            }
            else if (highlight.includes("order") && props.buttonType === orderType){
                elementId = "primary-btn-order";                
            }

            const element = document.getElementById(elementId);
            if (elementId != null && element != null){
                const animation = async () => {
                    await animate(element, { backgroundColor: "#FFFFFF80"}, {duration: 0.6});
                    if (element != null)
                        animate(element, { backgroundColor: backgroundColor}, {duration: 0.6});
                }                
                animation();
            }
        }
      }, [highlight]);

    function open(e){
        e.stopPropagation();        
        setStoryClicked1Time(true);
        setPlayInteractiveAnimation(false);
        props.open();
    }

    function getIcon(){
        switch (props.buttonType){
            case bookType: 
                return <TodayIcon sx={{width: 16 * sizeMultiplier, height: 16 * sizeMultiplier, paddingTop: 0.05 * sizeMultiplier, marginRight: sizeMultiplier !== 1 ? -0.4 : 0, color: textColor}} />;
            case shareType: 
                return <ShareIcon sx={{width: 16 * sizeMultiplier, height: 16 * sizeMultiplier, marginRight: sizeMultiplier !== 1 ? -0.4 : 0, color: textColor}} />;
            case contactType: 
                return <ContactSupportIcon sx={{width: 16 * sizeMultiplier, height: 16 * sizeMultiplier, paddingTop: 0.0 * sizeMultiplier, marginRight: sizeMultiplier !== 1 ? -0.4 : 0, color: textColor}} />;
            case orderType: 
                return <Moped sx={{width: 16 * sizeMultiplier, height: 16 * sizeMultiplier, paddingTop: 0.0 * sizeMultiplier, marginRight: sizeMultiplier !== 1 ? -0.4 : 0, color: textColor}} />;
            case applyType: 
                return <AssignmentIndIcon sx={{width: 16 * sizeMultiplier, height: 16 * sizeMultiplier, paddingTop: 0.05 * sizeMultiplier, marginRight: sizeMultiplier !== 1 ? -0.4 : 0, color: textColor}} />;
            default:
                return null;
        }
    }

    return (                
        <div style={{position: "absolute", zIndex: 10, left: x, top: y}}>
            <MaterialButton id={"primary-btn-"+props.buttonType} style={(props.buttonType === shareType) ? "branded-filled" : "branded-white-filled"} sx={{position: "absolute", }} color={textColor} bgColor={backgroundColor} icon={getIcon()} value={t(textKey)} width={buttonWidth} height={buttonHeight} onClick={open} />
        </div>
    );
}

export default PrimaryButton;